<template>
	<div>
		<Header :sel='3' @changePhone="changePhone" />
		

			<!-- * 内页banner * -->
			<div class="page-banner">
				<img src="@/assets/images/banner18.png">
				<div class="nybt">
					<h3>科研创新</h3>
				</div>
			</div>
			
			<!-- * 当前位置 * -->
			<div class="page-position">
				<div class="wh">
					当前位置：
					<a href="/">首页</a>
					&gt;
					<a href="javascript:void(0)" @click="goBack">科研创新</a> >{{detail.title}}
				</div>
			</div>
			
			<!-- * 主体部分 * -->
			<div class="page-wrap">
				<div class="wh clearfix">
					<!-- * 左侧 * -->
			
			
					<!-- * 右侧 * -->
					<div class="page-wrap-right">
			
						<div class="xypg-left-con2 hidden-sm hidden-xs clearfix">
							<div>
								<ul class="xypg-left-nav">
									<li :class="item.categoryCode == type ? 'clicked' : ''" v-for="item in actList">
										<a href="javascript:void(0)"
											@click="changeData(item.categoryCode, item.categoryName, item.url)">
											{{ item.categoryName }}</a>
										<div class="first-nav-btn"></div>
									</li>
								</ul>
							</div>
						</div>
			
			
			
						<div class="xypg-right-content">
							<!-- * 判断后台有没有录入多图 * -->
							<div>
								<!-- 产品详情页面 -->
								<div class="xypg-product-detail">
			
			
									<div class="product-detail-tab">
			
			
										<div class="product-detail-tabbox">
											<h1 class="xypg-detail-title" style="text-align: center;">{{detail.title}}</h1>
											<div class="product-detail-tabcon" v-html="detail.cmsArticleData?detail.cmsArticleData.content:''">
												
												
											</div>
										</div>
									</div>
								
								</div>
							</div>
			
							<!-- * 最近浏览 * -->
							<!-- * 最近浏览 * -->
			
			
						</div>
					</div>
			
					<!-- * 手机弹窗 * -->
			
				</div>
			</div>

			<Footer />



		<!--neirong-->


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'


	import {
		articleDetail,categorysortPage
	} from '@/api/reqFetch.js'

	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header,
		},
		data() {
			return {
				id: '',
				detail: {},
				showPhone: false,
				pdfUrl: '',
				pdfDoc: null,
				pageNum: 1,
				pageCount: 0,
				actList:[],
				type:'',
				title:''
			}
		},

		mounted() {
			this.id = this.$route.query.id
			this.getNewDetail();
			if(this.$route.query.type){
				this.type = this.$route.query.type
			    this.title = this.$route.query.title
				this.getCategorysortPage()
			}
			
		},

		methods: {
			changeData(id, title, href) {
			if (title == '创新平台') {
				let url = '/society?type=' + id + '&title=' + title
				this.$router.push(url)
			} else {
				this.$router.push({
					path: href+'&type='+id+'&title='+title
				})
				this.$router.go(0)
			}

		  },
			getCategorysortPage() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					res.data.map(item => {
						if (item.categoryName == '科研创新') {
							this.actList = item.children
							this.actList.sort((a, b) => a.orderNum - b.orderNum);
						}
					})

				});
			},
			goBack(){
				this.$router.go(-1)
			},
			changePhone(val) {
				this.showPhone = val
			},
			getNewDetail() {
				articleDetail({
					id: this.id
				}).then(res => {
					this.detail = res.data;
					try {
							let cmsArticleData = this.detail.cmsArticleData
						if(cmsArticleData && cmsArticleData.content){
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g, '<div class="su-space"></div>')
						}
						this.detail = {
							...this.detail,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}
				});
			},

			

		}
	}
</script>

<style scoped>
	/*内容*/
	.banner {
		background-image: url('../../assets/images/banner18.png');
	}
	.wh{width: 1200px; margin: 0 auto; }

	@media screen and (max-width: 1100px) {
		.wh{width: 94%; }}
</style>